import React, { FC } from 'react';
import styled from 'styled-components';
import { CourseItem } from './CourseItem';
import { useData, useDataV2 } from './useData';
import { appStore } from '@store';

const Title = styled.div`
	font-weight: 700;
	font-size: 24px;
	line-height: 28px;
	color: #000000;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`;

export const Course: FC = () => {
	const { academyPlanVersion } = appStore.abTestsStore.params;
	const data = academyPlanVersion === 'V3' ? useDataV2() : useData();
	return (
		<div>
			<Title>Get a personalized weight loss course:</Title>
			<Container>
				{data.map(item => (
					<CourseItem key={item} text={item} />
				))}
			</Container>
		</div>
	);
};
